const customerFragment = /* GraphQL */ `
    fragment customer on Customer {
        firstName
        lastName
        email
        phone
        addresses {
            edges {
                node {
                    firstName
                    lastName
                    address1
                    address2
                    city
                    countryCode
                    phone
                    postalCode
                }
            }
        }
    }
`
export { customerFragment }
